module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.6d1796a9.ttf";